module.exports = __webpack_public_path__ + "img/Taher.06146b3b.png";